module.exports = __webpack_public_path__ + "2604b81fc0e00941f5c2269db8f6cbae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/backgrounds/cover-4.jpg
// module id = 394
// module chunks = 0